







































































import { Component, Prop, Vue } from 'vue-property-decorator';
import { Action } from 'vuex-class';
import { maxLength, required } from 'vuelidate/lib/validators';
import { validationMixin } from 'vuelidate';
import Toast from '@/shared/services/toast';
import Modal from '@/shared/components/Modal.vue';
import { UPDATE_HOLIDAY } from '@/store/holidays/actionTypes';
import { HolidayViewModel } from '@/features/bots/models/holidayViewModel';
import VuelidateUtil from '@/shared/util/vuelidateUtil';
import HelpIcon from 'vue-material-design-icons/HelpCircleOutline.vue';

@Component({
	components: {
		Modal,
		HelpIcon
	},
	mixins: [validationMixin],
	validations: {
		name: {
			required,
			maxLength: maxLength(50),
			holidayNameValid: VuelidateUtil.objectName
		},
		dates: {
			required,
			$each: {
				date: {required, todayOrFutureValid: VuelidateUtil.todayOrFuture}
			}
		}
	}
})
export default class UpdateHoliday extends Vue {
	@Action(UPDATE_HOLIDAY) public updateHoliday: (request: HolidayViewModel) => Promise<HolidayViewModel>;

	@Prop() public holiday: HolidayViewModel;

	public name = '';
	public dates: any[] = [];

	public updateInProgress: boolean = false;

	public mounted() {
		this.name = this.holiday.name;
		if (this.holiday.dates) {
			this.dates = this.holiday.dates.map((d, key) => ({
				date: d,
				key
			}));
		} else {
			this.dates = [];
		}

		this.focusOnInput(this.$refs.nameInput as Vue);
	}

	public closeModal() {
		this.$emit('cancel');
	}

	public addDate() {
		this.dates.push({date: new Date(), key: Date.now()});
		this.$nextTick(() => {
			const dateInputs = this.$refs.dateInput as Vue[];
			const lastDateInput = dateInputs[dateInputs.length - 1];
			this.focusOnInput(lastDateInput);
		});
	}

	public deleteDate(index: number) {
		this.dates.splice(index, 1);
	}

	public getErrorMessage(vuelidate: any, prop: string, label: string) {
		if (VuelidateUtil.isValidationInvalid(vuelidate, prop, 'holidayNameValid')) {
			return `${label} must only contain letters, numbers, spaces, and the characters , - _ ( ) &`;
		}
		if (VuelidateUtil.isMaxLengthInvalid(vuelidate, prop)) {
			return `${label} must not be longer than ${VuelidateUtil.getAllowedMaxLength(vuelidate, prop)} characters`;
		}
		if (VuelidateUtil.isRequiredInvalid(vuelidate, prop)) {
			return prop === 'date' ? `A valid date is required` : `${label} must not be empty`;
		}
		if (VuelidateUtil.isValidationInvalid(vuelidate, prop, 'todayOrFutureValid')) {
			return `${label} must be today or in the future`;
		}
	}

	public async update() {
		if (this.updateInProgress) {
			return;
		}

		this.updateInProgress = true;
		try {
			const request = this.createRequestModel();
			const updatedHoliday = await this.updateHoliday(request);
			Toast.showSuccess('Holiday successfully updated');
			this.$emit('update', updatedHoliday);
		} catch (err) {
			Toast.showError(err.message);
		} finally {
			this.updateInProgress = false;
		}
	}

	private createRequestModel(): HolidayViewModel {
		return {
			id: this.holiday.id,
			name: this.name,
			dates: this.dates.map(d => d.date)
		};
	}

	private focusOnInput(component: Vue) {
		if (component) {
			const inputElements = component.$el.getElementsByTagName('input');
			if (inputElements.length === 1) {
				inputElements[0].focus();
			}
		}
	}
}
